//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    data: {
      type: Array,
      default () {
        return []
      }
    },
    type: {
      type: String,
      default: 'employees'
    },
    rowKey: {
      type: String,
      default: 'fio'
    },
    heightTable: {
      type: Number,
      default: 200
    }
  },
  data: function () {
    return {
      columnsTabPanelEmployee: [
        {
          name: 'fio',
          label: 'ФИО',
          align: 'left',
          field: 'fio',
          classes: 'class-bordered',
          headerStyle: 'width: 270px; white-space: pre-wrap;'
        },
        {
          name: 'engineerScore',
          label: 'Уровень',
          align: 'right',
          field: 'engineerScore',
          classes: 'class-bordered',
          headerStyle: 'width: 60px; white-space: pre-wrap;'
        },
        {
          name: 'skills',
          label: 'Навыки',
          align: 'left',
          field: 'skills',
          classes: 'class-bordered',
          headerStyle: 'width: 60px; white-space: pre-wrap;'
        }
      ],
      columnsTabPanelStock: [
        {
          name: 'toolName',
          label: 'Название',
          align: 'left',
          field: 'toolName',
          classes: 'class-bordered',
          headerStyle: 'width: 220px; white-space: pre-wrap;',
          sortable: true
        },
        {
          name: 'amount',
          label: 'Кол-во',
          align: 'left',
          field: 'amount',
          format: this.formatAmountMaterialesTable,
          classes: 'class-bordered',
          headerStyle: 'width: 90px; white-space: pre-wrap;',
          sortable: true
        },
        {
          name: 'unit',
          label: 'Ед. изм.',
          align: 'left',
          field: 'unit',
          classes: 'class-bordered',
          headerStyle: 'width: 90px; white-space: pre-wrap;',
          sortable: true
        },
        {
          name: 'stockName',
          label: 'Склад',
          align: 'left',
          field: 'stockName',
          format: this.formatStockNameMaterialesTable,
          classes: 'class-bordered',
          headerStyle: 'width: 90px; white-space: pre-wrap;',
          sortable: true
        }
      ],
      columnsTabPanelConditionsResults: [
        {
          name: 'condition',
          label: 'Условие',
          align: 'left',
          field: 'condition',
          format: this.formatConditionName,
          classes: 'class-bordered',
          headerStyle: 'width: 150px; white-space: pre-wrap;'
        },
        {
          name: 'type',
          label: 'Тип',
          align: 'left',
          field: 'type',
          format: this.formatConditionType,
          classes: 'class-bordered',
          headerStyle: 'width: 150px; white-space: pre-wrap;'
        },
        {
          name: 'notAchievedAction',
          label: 'Действие',
          align: 'left',
          field: 'notAchievedAction',
          format: this.formatConditionTypeAction,
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        },
        {
          name: 'value',
          label: 'Значение',
          align: 'right',
          field: 'value',
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        },
        {
          name: 'message',
          label: 'Сообщение',
          align: 'left',
          field: 'message',
          classes: 'class-bordered',
          headerStyle: 'width: 200px; white-space: pre-wrap;'
        },
        {
          name: 'score',
          label: 'Коэфф.',
          align: 'left',
          field: 'score',
          format: this.formatConditionScore,
          classes: 'class-bordered',
          headerStyle: 'width: 50px; white-space: pre-wrap;'
        }
      ],
      columnsTabPanelDepositions: [
        {
          name: 'requestNumber',
          label: 'Задание',
          align: 'left',
          field: 'requestNumber',
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        },
        {
          name: 'alias',
          label: 'Название',
          align: 'left',
          field: 'alias',
          classes: 'class-bordered',
          headerStyle: 'width: 160px; white-space: pre-wrap;'
        },
        {
          name: 'value',
          label: 'Значение',
          align: 'right',
          field: 'value',
          // format: this.renderDepositionValue,
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        },
        {
          name: 'score',
          label: 'Вклад',
          align: 'right',
          field: 'score',
          format: this.formatDepositionScore,
          classes: 'class-bordered',
          headerStyle: 'width: 100px; white-space: pre-wrap;'
        }
      ],
      pagination: {
        rowsPerPage: 10,
        page: 1
      }
    }
  },
  methods: {
    formatEmployeeSkills: function (skills) {
      const names = []
      if (skills) {
        for (let i = 0; i < skills.length; i++) {
          names.push(skills[i].name + ' (' + skills[i].level + ')')
        }
      }
      return names
    },
    formatConditionName: function (value) {
      return value ? value.name : ''
    },
    formatConditionType: function (value) {
      switch (value) {
        case 'equipment':
          return 'Оборудование'
        case 'qualification':
          return 'Квалификация'
        case 'tool':
          return 'Инструмент'
        case 'availabletool':
          return 'Наличие оборудования'
        case 'skill':
          return 'Навыки'
      }
      return ''
    },
    formatConditionTypeAction: function (value) {
      switch (value) {
        case 'alarm':
          return 'Предупреждение'
        case 'stop':
          return 'Запрет'
        case 'ignore':
          return 'Не учитывать'
      }
      return ''
    },
    formatConditionScore: function (value) {
      return value.toFixed(1)
    },
    renderDepositionValue: function (record) {
      let value = record.value.toFixed(2)
      const dimension = record.dimension
      if (dimension) {
        value += dimension
      }
      return value
    },
    formatDepositionScore: function (value) {
      return value.toFixed(2)
    },
    formatAmountMaterialesTable: function (amount) {
      if (amount) {
        let sumAmount = 0
        for (let i = 0; i < amount.length; i++) {
          sumAmount = sumAmount + amount[i]
        }
        return sumAmount
      } else {
        return 'Нет данных'
      }
    },
    formatStockNameMaterialesTable: function (stockName) {
      if (stockName) {
        return stockName.join(', ')
      } else {
        return 'Нет данных'
      }
    },
    getColumns: function (type) {
      let columns = []
      switch (type) {
        case 'employees':
          columns = this.columnsTabPanelEmployee
          break
        case 'stocktools':
          columns = this.columnsTabPanelStock
          break
        case 'unsuccessConditionsResults':
        case 'successConditionsResults':
          columns = this.columnsTabPanelConditionsResults
          break
        case 'depositions':
          columns = this.columnsTabPanelDepositions
          break
        default:
          break
      }
      return columns
    }
  }
}

